import RetencionShow from './RetencionShow'
export {RetencionShow}
export default RetencionShow
